export const environment = {
    production: true,
    linea: (() => {
        const origin = typeof document !== 'undefined' ? document.location.origin : '';
        //#region Entornos de desarrollo para cambios tipografías
        const stagingVenture = "venture.westeurope.5.azurestaticapps.net";
        const stagingRealEstate = "realestate.westeurope.5.azurestaticapps.net";
        const stagingFactoring = "segofactoring.westeurope.5.azurestaticapps.net";
        const stagingFunds = "funds.westeurope.5.azurestaticapps.net";
        const stagingCreative = "creative.westeurope.5.azurestaticapps.net";
        //#endregion
        if (origin.includes("venture.segofinance.com") || origin.includes(stagingVenture)) {
            return "venture";
        }
        else if (origin.includes("realestate.segofinance.com") || origin.includes(stagingRealEstate)) {
            return "realestate";
        }
        else if (origin.includes("factoring.segofinance.com") || origin.includes(stagingFactoring)) {
            return "factoring";
        }
        else if (origin.includes("funds.segofinance.com") || origin.includes(stagingFunds)) {
            return "funds";
        }
        else if (origin.includes("creative.segofinance.com") || origin.includes(stagingCreative)) {
            return "creative";
        }
        else {
            return "segofinance";
        }
    })(),
    apiCore: 'https://apim-sego-core-prod.azure-api.net/core/',
    apiVenture: 'https://apim-sego-core-prod.azure-api.net/venture/',
    apiRealEstate: 'https://apim-sego-core-prod.azure-api.net/realestate/',
    apiFactoring: 'https://apim-sego-core-prod.azure-api.net/factoring/',
    apiFunds: 'https://apim-sego-core-prod.azure-api.net/funds/',
    apiFacturacion: 'https://apim-sego-core-prod.azure-api.net/facturacion/',
    urlPlatformSego: "https://www.segofinance.com/",
    apiAudiovisual: 'https://apim-sego-core-prod.azure-api.net/audiovisual/',
    apiVideojuegos: 'https://apim-sego-core-prod.azure-api.net/videojuegos/',
    apiWebContent: "https://apim-sego-core-prod.azure-api.net/webcontent/",
    apiKey: "2e73914170f440bbb8e60ded6f77a41a"
};
